import React from 'react';
import Button from './Button';

function EmptyState({ icon = 'city', message, action, children }) {
  return (
    <div className='p-16 rounded-lg bg-gray-900 flex flex-col justify-center items-center gap-10 max-w-xl w-full text-gray-400'>
      <div className='flex flex-col items-center justify-center gap-10'>
        {icon === 'kitty' && <IconKitty />}
        {icon === 'city' && <IconCity />}
        <p className='font-medium text-xl text-center'>{message}</p>
      </div>

      {action?.onClick && (
        <Button onClick={action.onClick} loading={action.loading}>
          {action.text}
        </Button>
      )}
      {action?.href && <Button href={action.href}>{action.text}</Button>}
      {children && <div>{children}</div>}
    </div>
  );
}

const IconCity = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512' className='w-[65px]'>
      <path
        d='M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z'
        fill='currentColor'
      />
    </svg>
  );
};

const IconKitty = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512' className='w-[65px]'>
      <path
        d='M544 160c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7zM379.2 89.6L349.8 50.4C369.1 38.7 391.8 32 416 32s46.9 6.7 66.2 18.4L452.8 89.6c-3 4-7.8 6.4-12.8 6.4H392c-5 0-9.8-2.4-12.8-6.4zM448 316.8C521 302 576 237.4 576 160C576 71.6 504.4 0 416 0S256 71.6 256 160c0 11.7 1.3 23.1 3.6 34.1c-54.9 8.1-102.2 39.5-131.6 83.8V192.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1C18.4 94.1 2.4 106.5 .2 124s10.2 33.5 27.8 35.7l7.9 1c16 2 28 15.6 28 31.8V416c0 53 43 96 96 96H304c17.7 0 32-14.3 32-32s-14.3-32-32-32H248L384 339.2V480c0 17.7 14.3 32 32 32s32-14.3 32-32V316.8zM400 160c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zM199.5 12.3c-2.6-7-12.4-7-15 0L173.8 41.1c-.8 2.2-2.5 3.9-4.7 4.7L140.3 56.5c-7 2.6-7 12.4 0 15l28.8 10.7c2.2 .8 3.9 2.5 4.7 4.7l10.7 28.8c2.6 7 12.4 7 15 0l10.7-28.8c.8-2.2 2.5-3.9 4.7-4.7l28.8-10.7c7-2.6 7-12.4 0-15L214.9 45.8c-2.2-.8-3.9-2.5-4.7-4.7L199.5 12.3z'
        fill='currentColor'
      />
    </svg>
  );
};

export default EmptyState;
